import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SuperReturnBar from '@/components/owner/SuperReturnBar.vue'
import AppConfirmHost from '@/components/common/AppConfirmHost.vue'
import FeatureTourOverlay from '@/components/common/FeatureTourOverlay.vue'
import PwaInstallPrompt from '@/components/common/PwaInstallPrompt.vue'
import { useAppBackNavigation } from '@/composables/useAppBackNavigation'
import { usePortraitLock } from '@/composables/usePortraitLock'
import { captureInstallSourceFromUrl } from '@/composables/usePwaInstall'

// 문자 링크 query를 스플래시 전에 세션에 남김

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

captureInstallSourceFromUrl()

useAppBackNavigation()
usePortraitLock()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SuperReturnBar),
    _createVNode(_component_router_view),
    _createVNode(FeatureTourOverlay),
    _createVNode(PwaInstallPrompt),
    _createVNode(AppConfirmHost)
  ], 64))
}
}

})